import { useEffect } from 'react';

type SavedStyles = Pick<CSSStyleDeclaration, 'overflow' | 'position' | 'top' | 'left' | 'right' | 'width' | 'paddingRight'>;

let lockCount = 0;
let savedScrollY = 0;
let savedStyles: SavedStyles | null = null;
let savedHtmlOverscroll = '';

function lock() {
  const { body, documentElement } = document;
  const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
  savedScrollY = window.scrollY;
  savedStyles = {
    overflow: body.style.overflow,
    position: body.style.position,
    top: body.style.top,
    left: body.style.left,
    right: body.style.right,
    width: body.style.width,
    paddingRight: body.style.paddingRight,
  };
  savedHtmlOverscroll = documentElement.style.overscrollBehavior;

  body.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = `-${savedScrollY}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
  documentElement.style.overscrollBehavior = 'none';
}

function unlock() {
  const { body, documentElement } = document;
  if (savedStyles) Object.assign(body.style, savedStyles);
  documentElement.style.overscrollBehavior = savedHtmlOverscroll;
  savedStyles = null;
  window.scrollTo({ top: savedScrollY, left: 0, behavior: 'instant' as ScrollBehavior });
}

export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;
    if (lockCount === 0) lock();
    lockCount += 1;
    return () => {
      lockCount -= 1;
      if (lockCount === 0) unlock();
    };
  }, [locked]);
}
